export default function getTopRow(contentState, tableId) {
  const blocks = contentState.getBlocksAsArray();
  for (const block of blocks) {
    if (block.get("type") === "Table" && block.getIn(["data", "tableId"]) === tableId && block.getIn(["data", "is_deleted"]) === false) {
      const row = block.getIn(["data", "row"]);
      return row;
    }
  }
}